import { fork } from 'redux-saga/effects';
import platformConfigApi from '../../interfaces/api';
import platformConfigFetchSaga from './fetch-saga';

export default function* platformConfigtSaga(api: platformConfigApi) {
  // order of the forked sub-sagas doesn't matter
  yield fork(platformConfigFetchSaga, api);
}
